import axios from '@/axios';
import type { Availability } from '@/types';

interface Options {
  locationId: string;
  offset: number;
  bookingId: string | null;
  serviceIds?: number[];
  range: number;
  widgetId: string | null;
}

interface Params {
  range: number;
  offset: number;
  widget_id?: string;
  appointment_id?: string;
  service_ids?: number[];
}

export const loadAvailabilities: (
  options: Options
) => Promise<Availability[] | null> = ({
  locationId,
  bookingId,
  serviceIds,
  offset,
  range,
  widgetId
}) => {
  const params: Params = {
    range: range,
    offset
  };

  if (bookingId) {
    params.appointment_id = bookingId;
  } else {
    params.service_ids = serviceIds;
  }

  if (widgetId) {
    params.widget_id = widgetId;
  }

  return axios
    .get(`/locations/${locationId}/availabilities`, { params })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
      return null;
    })
    .catch((e) => {
      throw new Error('Server error.', e);
    });
};
